import { WaterlilyClient } from '@/api/waterlily';

export type UnderwritingPromptStatus = 'draft' | 'published' | 'archived';

export interface UnderwritingPromptVersion {
  id: string;
  promptType: string;
  promptKey: string;
  versionNumber: number;
  content: string;
  contentFormat: string;
  status: UnderwritingPromptStatus;
  notes: string | null;
  createdByEmail: string;
  createdByName: string;
  createdAt: string;
  publishedByEmail: string | null;
  publishedByName: string | null;
  publishedAt: string | null;
}

export type UnderwritingPromptVersionListItem = Omit<UnderwritingPromptVersion, 'content'> & {
  contentLength: number;
};

export const wizardUnderwritingGuidelinesKeys = {
  all: ['wizardUnderwritingGuidelines'] as const,
  versions: (params?: { promptKey?: string; status?: UnderwritingPromptStatus }) =>
    ['wizardUnderwritingGuidelines', 'versions', { params: params ?? {} }] as const,
  version: (versionId: string) =>
    ['wizardUnderwritingGuidelines', 'version', versionId] as const,
};

export const wizardUnderwritingGuidelinesApi = {
  listVersions: (params?: { promptKey?: string; status?: UnderwritingPromptStatus }) =>
    WaterlilyClient.get<UnderwritingPromptVersionListItem[]>(
      '/wizard-underwriting-prompt-versions',
      params,
    ),

  getVersion: (versionId: string) =>
    WaterlilyClient.get<UnderwritingPromptVersion>(
      `/wizard-underwriting-prompt-version/${versionId}`,
    ),

  saveDraft: (data: { promptKey: string; content: string }) =>
    WaterlilyClient.post<UnderwritingPromptVersion>('/wizard-underwriting-prompt-draft', data),

  updateDraft: (draftId: string, data: { content: string }) =>
    WaterlilyClient.put<UnderwritingPromptVersion>(
      `/wizard-underwriting-prompt-draft/${draftId}`,
      data,
    ),

  discardDraft: (draftId: string) =>
    WaterlilyClient.delete<{ success: boolean }>(
      `/wizard-underwriting-prompt-draft/${draftId}`,
    ),

  publishDraft: (draftId: string, data: { notes: string }) =>
    WaterlilyClient.post<UnderwritingPromptVersion>(
      `/wizard-underwriting-prompt-publish/${draftId}`,
      data,
    ),
};

export interface CarrierGuidelineDescriptor {
  promptKey: string;
  carrierName: string;
}

export const CARRIER_GUIDELINES: CarrierGuidelineDescriptor[] = [
  { promptKey: 'underwriting-nw-guidance', carrierName: 'Nationwide' },
  { promptKey: 'underwriting-oa-guidance', carrierName: 'OneAmerica' },
  { promptKey: 'underwriting-cs-guidance', carrierName: 'CareScout' },
  { promptKey: 'underwriting-lincoln-guidance', carrierName: 'Lincoln Financial' },
  { promptKey: 'underwriting-securian-guidance', carrierName: 'Securian Financial' },
  { promptKey: 'underwriting-nyl-asset-flex-guidance', carrierName: 'New York Life' },
];
